import { render, staticRenderFns } from "./selectContact.vue?vue&type=template&id=288f7620&scoped=true"
import script from "./selectContact.vue?vue&type=script&lang=js"
export * from "./selectContact.vue?vue&type=script&lang=js"
import style0 from "./selectContact.vue?vue&type=style&index=0&id=288f7620&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288f7620",
  null
  
)

export default component.exports